import React from 'react';

const InputCheckbox = ({col, label, disabled, id, onChange, checked, inputClassName = "", labelClassName = ""}) => {

    return (
        <div className={"flex items-center " + col}>
            <input onChange={onChange} checked={checked} id={id} type="checkbox" disabled={disabled}
                   className={`w-4 h-4 bg-gray-100 border-gray-300 rounded ${inputClassName}`}/>
            <label htmlFor={id} className={`ms-2 text-sm font-medium ${labelClassName}`}>
                {label}
            </label>
        </div>
    );
};

export default InputCheckbox;
